import { useFlags } from 'launchdarkly-react-client-sdk';

import { useMeterType } from 'hooks/useMeterType';

export const usePeakSave = () => {
  const { releasePeakSave } = useFlags();
  const { hasElectricityTOUMeter } = useMeterType();

  const showPeakSaveRegistration =
    releasePeakSave && hasElectricityTOUMeter;

  return {
    showPeakSaveRegistration
  };
};
